export default "__VITE_ASSET__ByEk$01b__"